import { Typography } from '@hulu/react-style-components';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  height: 14px;
  align-items: center;
`;

export const EmptyIcon = styled.span`
  height: 20px;
  width: 20px;
  background-color: transparent;
  border: 1px solid ${({ theme }): string => theme.admanColors!.gray.light.fg[4]};
  border-radius: 50%;
`;

export const StepName = styled(Typography)`
  line-height: 12px;
  margin-left: ${({ theme }): string => theme.spacers!.spacer02};
`;
